import { FormGroup } from '@angular/forms';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const getCoopEdilizieGroup = (form: FormGroup): FormGroup => getGroup(form, formPaths.schedaCoopEdil);

export const getCoopEdilizieControl = (form: FormGroup, path: string) => getControl(form, `${formPaths.schedaCoopEdil}.${path}`);
